import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { UiButton } from "../../../../components";
import "./style.scss";

const ApproveLawyerModal = ({
    isVisible,
    onClose,
    onConfirm,
    isLoading
}) => {
    const handleApprove = () => {
        onConfirm();
        onClose();
    };

    return (
        <Modal
            open={isVisible}
            onCancel={onClose}
            footer={null}
            width={400}
            className="approve-lawyer-modal"
            centered
        >
            <div className="approve-modal-content">
                <div className="approve-modal-header">
                    <ExclamationCircleOutlined className="warning-icon" />
                    <h3 className="modal-title">Are Sure Approve this Advocate</h3>
                </div>
                <div className="modal-footer">
                    <UiButton 
                        className="cancel-btn"
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        No
                    </UiButton>
                    <UiButton 
                        type="primary"
                        className="approve-btn-2"
                        onClick={handleApprove}
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        Approve
                    </UiButton>
                </div>
            </div>
        </Modal>
    );
};

export default ApproveLawyerModal;